(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  (function () {
    var cartSections = document.querySelectorAll('[data-cart-editorial]');

    cartSections.forEach(function (section) {
      var form = section.querySelector('.cart-editorial__form');
      var updateButton = section.querySelector('.cart-editorial__update-trigger');

      if (!form || !updateButton) {
        return;
      }

      function submitUpdates() {
        if (typeof form.requestSubmit === 'function') {
          form.requestSubmit(updateButton);
          return;
        }

        updateButton.click();
      }

      section.addEventListener('click', function (event) {
        var trigger = event.target.closest('[data-quantity-trigger]');

        if (!trigger) {
          return;
        }

        var quantityRoot = trigger.closest('[data-quantity-picker]');

        if (!quantityRoot) {
          return;
        }

        var input = quantityRoot.querySelector('[data-cart-quantity-input]');

        if (!input) {
          return;
        }

        var minimum = parseInt(input.getAttribute('min') || '1', 10);
        var current = parseInt(input.value || minimum, 10);
        var step = parseInt(trigger.getAttribute('data-quantity-trigger') || '0', 10);

        if (Number.isNaN(current)) {
          current = minimum;
        }

        current += step;

        if (current < minimum) {
          current = minimum;
        }

        input.value = current;
        submitUpdates();
      });

      section.addEventListener('change', function (event) {
        var input = event.target.closest('[data-cart-quantity-input]');

        if (!input) {
          return;
        }

        var minimum = parseInt(input.getAttribute('min') || '1', 10);
        var value = parseInt(input.value || minimum, 10);

        if (Number.isNaN(value) || value < minimum) {
          input.value = minimum;
        }

        submitUpdates();
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.addEventListener('click', function(event) {
    var toggle = event.target.closest('[data-mobile-menu-toggle]');
    var header = event.target.closest('[data-site-header]');

    if (toggle) {
      var menuId = toggle.getAttribute('aria-controls');
      var menu = document.getElementById(menuId);
      var isExpanded = toggle.getAttribute('aria-expanded') === 'true';

      toggle.setAttribute('aria-expanded', String(!isExpanded));
      toggle.classList.toggle('is-open', !isExpanded);

      if (menu) {
        menu.hidden = isExpanded;
      }

      return;
    }

    if (event.target.closest('[data-mobile-menu-link]') && header) {
      var activeToggle = header.querySelector('[data-mobile-menu-toggle]');
      var activeMenu = header.querySelector('[data-mobile-menu]');

      if (activeToggle) {
        activeToggle.setAttribute('aria-expanded', 'false');
        activeToggle.classList.remove('is-open');
      }

      if (activeMenu) {
        activeMenu.hidden = true;
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-featured-product"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function(event) {
    var thumb = event.target.closest('[data-featured-gallery-thumb]');

    if (!thumb) return;

    var gallery = thumb.closest('[data-featured-gallery]');

    if (!gallery) return;

    var image = gallery.querySelector('.home-featured-product__main-image');

    if (!image) return;

    image.src = thumb.dataset.featuredGalleryImage;
    image.alt = thumb.dataset.featuredGalleryAlt || image.alt;

    gallery.querySelectorAll('[data-featured-gallery-thumb]').forEach(function(item) {
      item.classList.toggle('is-active', item === thumb);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-buy-box-sticky"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var sections = document.querySelectorAll('[data-product-buy-box]');

    sections.forEach(function(root) {
      var section = root.closest('.product-buy-box-sticky');

      if (!section) return;

      var variantDataScript = section.querySelector('[data-product-variants]');
      var variantIdInput = root.querySelector('[data-variant-id-input]');
      var variantSelect = root.querySelector('[data-variant-select]');
      var priceTarget = root.querySelector('[data-product-price]');
      var sizeTarget = root.querySelector('[data-product-size]');
      var sizeRow = root.querySelector('[data-product-size-row]');
      var purchasePriceTarget = root.querySelector('[data-purchase-price]');
      var purchaseRows = root.querySelectorAll('[data-purchase-row]');
      var purchaseOptions = root.querySelectorAll('[data-purchase-option]');
      var subscriptionRow = root.querySelector('[data-subscription-row]');
      var sellingPlanSelect = root.querySelector('[data-selling-plan-select]');
      var sellingPlanInput = root.querySelector('[data-selling-plan-input]');
      var sellingPlanSummary = root.querySelector('[data-selling-plan-summary]');
      var subscriptionFields = root.querySelector('[data-subscription-fields]');
      var addToCartButton = root.querySelector('[data-add-to-cart-button]');
      var addToCartLabel = root.querySelector('[data-add-to-cart-label]');
      var variants = [];

      if (!variantIdInput || !priceTarget || !addToCartButton || !addToCartLabel) return;

      if (variantDataScript) {
        try {
          variants = JSON.parse(variantDataScript.textContent);
        } catch (error) {
          variants = [];
        }
      }

      function getCheckedPurchaseOption() {
        var selected = null;

        purchaseOptions.forEach(function(option) {
          if (option.checked) {
            selected = option;
          }
        });

        return selected;
      }

      function syncPurchaseRowState() {
        var selected = getCheckedPurchaseOption();

        purchaseRows.forEach(function(row) {
          var input = row.querySelector('[data-purchase-option]');
          row.classList.toggle('is-selected', !!selected && input === selected);
        });

        if (!subscriptionFields) return;

        if (!selected) {
          subscriptionFields.hidden = true;
          return;
        }

        subscriptionFields.hidden = selected.value != 'subscription';
      }

      function syncSellingPlanValue() {
        var selected = getCheckedPurchaseOption();

        if (!sellingPlanInput) return;

        if (!selected) {
          sellingPlanInput.value = '';
          sellingPlanInput.disabled = true;
          return;
        }

        if (selected.value == 'subscription' && sellingPlanSelect && !sellingPlanSelect.disabled && sellingPlanSelect.value) {
          sellingPlanInput.value = sellingPlanSelect.value;
          sellingPlanInput.disabled = false;
          return;
        }

        sellingPlanInput.value = '';
        sellingPlanInput.disabled = true;
      }

      function renderSellingPlans(variant) {
        var subscriptionInput;

        if (!sellingPlanSelect || !subscriptionFields || !subscriptionRow) return;

        subscriptionInput = subscriptionRow.querySelector('[data-purchase-option]');

        if (!subscriptionInput) return;

        sellingPlanSelect.innerHTML = '';

        if (!variant.sellingPlans || !variant.sellingPlans.length) {
          subscriptionInput.checked = false;
          subscriptionInput.disabled = true;
          subscriptionRow.classList.add('is-disabled');
          subscriptionFields.hidden = true;

          if (sellingPlanSummary) {
            sellingPlanSummary.textContent = '';
          }

          if (purchaseOptions.length) {
            purchaseOptions[0].checked = true;
          }

          sellingPlanSelect.disabled = true;
          syncPurchaseRowState();
          syncSellingPlanValue();
          return;
        }

        subscriptionInput.disabled = false;
        subscriptionRow.classList.remove('is-disabled');
        sellingPlanSelect.disabled = false;

        variant.sellingPlans.forEach(function(plan, index) {
          var option = document.createElement('option');

          option.value = plan.id;
          option.textContent = plan.name;

          if (index === 0) {
            option.selected = true;
          }

          sellingPlanSelect.appendChild(option);
        });

        if (sellingPlanSummary) {
          sellingPlanSummary.textContent = variant.sellingPlans[0].name;
        }

        syncSellingPlanValue();
      }

      function updateVariant(variantId) {
        var selectedVariant = null;

        variants.forEach(function(variant) {
          if (String(variant.id) == String(variantId)) {
            selectedVariant = variant;
          }
        });

        if (!selectedVariant) return;

        variantIdInput.value = selectedVariant.id;
        priceTarget.textContent = selectedVariant.price;

        if (purchasePriceTarget) {
          purchasePriceTarget.textContent = selectedVariant.price;
        }

        if (sizeTarget && sizeRow) {
          sizeTarget.textContent = selectedVariant.sizeLabel || '';
          sizeRow.classList.toggle('is-hidden', !selectedVariant.sizeLabel);
        }

        addToCartButton.disabled = !selectedVariant.available;
        addToCartLabel.textContent = selectedVariant.available
          ? addToCartButton.dataset.availableLabel
          : addToCartButton.dataset.unavailableLabel;

        renderSellingPlans(selectedVariant);
        syncPurchaseRowState();
        syncSellingPlanValue();
      }

      purchaseOptions.forEach(function(option) {
        option.addEventListener('change', function() {
          syncPurchaseRowState();

          if (sellingPlanSummary && sellingPlanSelect && sellingPlanSelect.value) {
            sellingPlanSummary.textContent = sellingPlanSelect.options[sellingPlanSelect.selectedIndex].text;
          }

          syncSellingPlanValue();
        });
      });

      if (variantSelect) {
        variantSelect.addEventListener('change', function(event) {
          updateVariant(event.target.value);
        });
      }

      if (sellingPlanSelect) {
        sellingPlanSelect.addEventListener('change', function(event) {
          if (sellingPlanSummary) {
            sellingPlanSummary.textContent = event.target.options[event.target.selectedIndex].text;
          }

          syncSellingPlanValue();
        });
      }

      updateVariant(variantSelect ? variantSelect.value : variantIdInput.value);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
